import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import ExchangeIcon from '../../../assets/icons/exchange-icon';
import SignIcon from '../../../assets/icons/sign-icon';
import DetailsContainer from '../../../containers/details-container';
import GoBack from '../../../containers/go-back';
import AppPageMain from '../../../modules/app-page/app-page--main';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import PageHeader from '../../../modules/page-header';
import StatusBadge from '../../../modules/status-badge/status-badge';
import UiSelect from '../../../modules/ui/ui-select/ui-select';
import { useAppDispatch } from '../../../store';
import { setExchange } from '../../../store/actions/exchange';
import { RootState } from '../../../types';
import { getFormatDate } from '../../../utils/utils';
import { BankType } from '../mock';
import { useSign } from 'hooks';
import './index.scss';

const ExchangeRequest: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const { exchangeInfo, id, isHistory } = history.location.state;
  const ExchangeBanks = useSelector((s: RootState) => s.exchange.exchangeBanks);
  const exchangeHistory = useSelector(
    (s: RootState) => s.exchange.exchangeHistory
  );

  const {
    certificatesList,
    selectedCertificate,
    onUserSelectCertificate,
  } = useSign();

  const exInfo = id
    ? exchangeHistory.find((e: any) => e.id === id)
    : exchangeInfo;

  const detailsList = [
    [
      {
        title: 'Оператор обмена:',
        value: '“Лайтхаус”',
      },
      {
        title: 'ИНН:',
        value: '4342424445',
      },
    ],
    [
      {
        title: 'Курс обмена:',
        value: `1 ${ExchangeBanks[exInfo.saleBank as BankType].name} = ${
          ExchangeBanks[exInfo.saleBank as BankType].rate[
            exInfo.buyBank as BankType
          ]
        } ${ExchangeBanks[exInfo.buyBank as BankType].name}`,
      },
      {
        title: 'Комиссия:',
        value: `${(Number(exInfo.sale) * 0.2).toFixed(2)} ${
          ExchangeBanks[exInfo.saleBank as BankType].name
        }`,
      },
    ],
    [
      {
        title: 'Дата создания:',
        value: getFormatDate(new Date()),
      },
    ],
  ];

  const handleSignExchange = () => {
    dispatch(setExchange({ ...exInfo, id: exchangeHistory?.length + 1 })).then(
      () =>
        history.push(`/external-exchange-info/${exchangeHistory?.length + 1}`, {
          id: exchangeHistory?.length + 1,
        })
    );
  };

  return (
    <AppPageMain>
      <div className="container">
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35">
            <PageHeader
              items={[
                {
                  link: isHistory ? '/history' : '/exchange',
                  title: isHistory ? 'История' : 'Обмен',
                },
              ]}
              iconType={isHistory ? 'history' : 'exchange'}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-19 col-lg-27 col-xl-35 exchange-request-container">
            <DetailsContainer
              title="Обмен цифровых финансовых активов"
              onClose={() =>
                history.push(isHistory ? '/history' : '/exchange', {
                  tabName: isHistory && 'exchange',
                })
              }
              infoTitle={{
                steps: [
                  { title: 'Валюта и сумма', active: false },
                  { title: 'Подписание', active: !id },
                  { title: 'Статус', active: !!id },
                ],
                title: id ? 'Заявка' : 'Проверьте и подпишите:',
                description: (
                  <span>
                    Обмен цифровых финансовых активов: <br />
                    {Number(exInfo.sale).toLocaleString('ru')}{' '}
                    {ExchangeBanks[exInfo.saleBank as BankType].name}{' '}
                    <ExchangeIcon /> {Number(exInfo.buy).toLocaleString('ru')}{' '}
                    {ExchangeBanks[exInfo.buyBank as BankType].name}
                  </span>
                ),
                status: id && <StatusBadge title="Исполнено" color="green" />,
              }}
              leftContent={{
                title: 'Детали операции:',
                detailsList: detailsList,
              }}
              footer={
                !id && (
                  <div className="flex justify-between">
                    <GoBack onClick={() => history.push('/exchange')} />
                    <div className="flex justify-end">
                      <UiSelect
                        label="Выберите подпись"
                        options={certificatesList}
                        lg
                        value={selectedCertificate}
                        onChange={onUserSelectCertificate}
                      />
                      <IconBtn
                        onClick={handleSignExchange}
                        lg
                        disabled={!selectedCertificate}
                        icon={<SignIcon />}
                        title="Подписать"
                      />
                    </div>
                  </div>
                )
              }
            />
          </div>
        </div>
      </div>
    </AppPageMain>
  );
};

export default ExchangeRequest;
